import { gql } from '@apollo/client';
import { COHORT_SUMMARY } from '../fragments';

export const GET_ALL_COHORT = gql`
  query getAllCohort {
    cohorts {
      ...CohortSummary
    }
  }
  ${COHORT_SUMMARY}
`;

export const GET_SINGLE_COHORT = gql`
  query getSingleCohort($id: String!) {
    cohort(id: $id) {
      id
      name
      description
      createdAt
      subjects {
        id
        name
      }
    }
  }
`;

/** The heading on the student subject list — the name alone. */
export const GET_SINGLE_COHORT_NAME = gql`
  query getCohortName($id: String!) {
    cohort(id: $id) {
      id
      name
    }
  }
`;

/**
 * The cohorts the caller belongs to. Replaces `userCohorts(where:)`, which
 * took a filter and so could be pointed at anyone's membership.
 */
export const GET_USER_COHORT = gql`
  query getMyCohorts {
    me {
      id
      cohorts {
        id
        name
      }
    }
  }
`;
